const partnerRoles = ['partner', 'gpartner', 'epartner', 'forpet', 'veterinary', 'partner_mo']
export function partnerDisable(userInfo: { roles: string[] }) {
  const isPartner = partnerRoles.some(role => userInfo.roles.includes(role))
  const isShopManager = userInfo.roles.includes('shop_manager')
  if (isShopManager) return false
  return isPartner
}
